// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../lastDayOfYear/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var lastDayOfYear = convertToFP(fn, 1);
export default lastDayOfYear;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/lastDayOfYear/index.js
// module id = 956
// module chunks = 0